import React from "react";
import SEO from "../../components/SEO";

const FaceShapeGuide = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <SEO 
        title="How to Choose Sunglasses for Your Face Shape"
        description="Learn how to choose the perfect sunglasses for your face shape. Style guide by Mark & Luth."
      />

      <h1>How to Choose Sunglasses for Your Face Shape</h1>

      <p>
        Choosing the right sunglasses depends on your face shape. 
        The right match enhances your overall appearance.
      </p>

      <h2>Face Shapes & Styles</h2>
      <ul>
        <li>Round Face → Square frames</li>
        <li>Square Face → Round frames</li>
        <li>Oval Face → Almost all styles</li>
        <li>Heart Shape → Light frames</li>
      </ul>
    </div>
  );
};

export default FaceShapeGuide;